module.exports = __webpack_public_path__ + "images/1-new.png?a8576ea3a32869d81cfbc6890c9aa6b8";


//////////////////
// WEBPACK FOOTER
// ./src/pages/noko/info/1-new.png
// module id = 6e52b08ffbbe0ff5af0b
// module chunks = 47